import { useOrder } from "@/context";
import { loadFieldMapping, loadFieldMappingLabels } from "@/services";
import { VTEX_PROPERTIES } from "@/constants";

export const APPLY_TRIGGER_KEY = 'conciex:apply-trigger'

export function useCampos() {
  const { order } = useOrder();

  const mapping = loadFieldMapping();
  const mappingLabels = loadFieldMappingLabels();

  const labels: string[] = [];
  const values: string[] = [];

  for (const [zendeskFieldId, vtexKey] of Object.entries(mapping)) {
    if (!vtexKey) continue;
    const zendeskTitle = mappingLabels[zendeskFieldId]?.zendeskTitle ?? vtexKey;
    const resolvedValue = order
      ? (VTEX_PROPERTIES.find((p) => p.key === vtexKey)?.getValue(order) ?? "—")
      : "—";
    labels.push(zendeskTitle);
    values.push(resolvedValue);
  }

  function handleApplyData() {
    localStorage.setItem(APPLY_TRIGGER_KEY, String(Date.now()))
  }

  return { labels, values, handleApplyData };
}
